export class SortCriteria {
    field: string;
    ascending: boolean;
}
export class FiltroActividades {
    numberOT: number;
    activity: number;
    dateFrom: Date;
    dateUntil: Date;
    state: String;
    code: string;
    name: string;
    section: string;
    max = 100;
    min = 0;
    sortCriteriaList: SortCriteria[] = [
        { field: 'ot', ascending: false },
        { field: 'activity', ascending: false },
        { field: 'section', ascending: false },
        { field: 'code', ascending: false },
        { field: 'name', ascending: false },
        { field: 'score', ascending: false },
        { field: 'fecha', ascending: false },
        { field: 'avisos', ascending: false }

    ]
}